export enum Routes {
	WEBSERVICES = "?webservices",
	STATISTICS = "?statistics",
	LOGS = "?logs",
	SUPPORT = "?support",
	CONNECTIONS = "?connections",
	DOCUMENTATION = "?documentation",
	SESSIONS = "?sessions",
	SERVER_RESTART = "?server/restart",
	SERVER_PROXY = "?server/proxy",
	SERVER_OAUTH = "?server/oauth",
	SERVER_LICENSE = "?server/license",
	SERVER_KEYSTORE = "?server/keystore",
	SERVER_TRUSTSTORE = "?server/truststore",
	SERVER_TSA = "?server/tsa",
	SERVER_AUTH = "?server/auth",
	PORTAL_NEWS = "?portal/news",
	PORTAL_USERS = "?portal/users",
	PORTAL_USERSOURCE = "?portal/usersource",
	PORTAL_OAUTH = "?portal/oauth",
	PORTAL_FUNCTIONS = "?portal/functions",
	PORTAL_DESIGN = "?portal/design",
	PORTAL_AUTH = "?portal/auth"
}